<script setup lang="ts">
import { ref } from "vue";
import { getRandomBg } from "../utils/randomBg";
import { RequestUser, approveUser, rejectUser } from "../states/waitRoomState.ts";
const props = defineProps<{
  user: RequestUser;
}>();
const getAvatarText = (name: string) => {
  let res = "";
  if (name) {
    const nf = name.split(" ");
    res += nf[0][0].toUpperCase();
    if (nf[1] && nf[1].length > 0) {
      res += nf[1][0].toUpperCase();
    }
  }
  return res;
};
const item = ref<HTMLElement | null>(null);
const rejectControl = async () => {
  await rejectUser(props.user.id)
}

const approveControl = async () => {
  await approveUser(props.user.id)
}
</script>
<template>
  <div ref="item" class="user-item-in-wait-list">
    <div class="avatar" :style="{
      backgroundColor: getRandomBg(getAvatarText(user.displayedName)),
    }">
      <img v-if="user.avatar" :src="user.avatar" alt="" />
      <span v-else class="avatar-text">{{
        getAvatarText(user.displayedName)
        }}</span>
    </div>
    <div class="info">
      <span class="main">{{ user.displayedName }}</span>
    </div>
    <div class="controls">
      <div class="control reject" @click="rejectControl">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="2" />
        </svg>
      </div>
      <div class="control accept" @click="approveControl">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.4498 6.67135L9.55033 16.5708L4.60059 11.6211" stroke="currentColor" stroke-width="2" />
        </svg>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.user-item-in-wait-list {
  width: 100%;
  height: 68px;
  padding: 10px 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 4px;
  border: 2px solid transparent;
  transition: border-color ease-in 200ms;

  &:hover {
    background-color: #494949;
  }
}

.controls {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & .control {
    width: 24px;
    height: 24px;
    flex-shrink: 0;

    &.reject {
      color: var(--danger-button-regular);
      &:hover {
        color: var(--danger-button-hover);
      }
    }

    &.accept {
      color: var(--primary-button-regular);
      &:hover {
        color: var(--primary-button-hover);
      }
    }
  }
}

.avatar {
  width: 44px;
  height: 44px;
  margin-right: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar img {
  width: 44px;
  height: 44px;
}

.avatar .avatar-text {
  width: 100%;
  text-align: center;
  color: #ffffff;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100px;
  flex-grow: 1;
}

.info .main {
  color: #ececec;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.main {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
